<template>
  <div>
    <div style="min-height: 560px" class="google-map" ref="mapa"></div>
    <div class="legenda py-1 px-2 blue white--text font-weight-medium">
      <div>
        <img
          style="height: 22px"
          src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
        />Garagem
        <img
          style="height: 22px"
          src="http://maps.google.com/mapfiles/ms/icons/red-dot.png"
        />Carro
      </div>
      <v-spacer></v-spacer>
      <div>
        <!-- Distância:  -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'google-map',
  props: {
    waypts: Array,
    destination: {
      required: false,
    },
    showRoute: {
      required: false,
    },
    origin: {
      required: false,
    },
  },

  watch: {
    showRoute: function() {
      this.initMap();
    },
  },

  data: function() {
    return {
      directionsRenderer: null,
      directionsService: null,
    };
  },

  mounted: function() {
    this.initMap();
  },

  methods: {
    initMap() {
      const element = this.$refs.mapa;
      const options = {
        zoom: 14,
        center: new google.maps.LatLng(-19.9166813, -43.9344931),
      };
      const map = new google.maps.Map(element, options);
      this.directionsRenderer = new google.maps.DirectionsRenderer({
        polylineOptions: {
          strokeColor: 'blue',
          strokeOpacity: 0.7,
          strokeWeight: 3,
        },
        suppressMarkers: true,
      });
      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer.setMap(map);
      let markerA = new google.maps.Marker({
        position: this.origin,
        title: 'Carro',
        icon: {
          url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
        },
        map: map,
      });
      let markerB = new google.maps.Marker({
        position: this.destination,
        title: 'Garagem',
        icon: {
          url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        },
        map: map,
      });
      this.calculateAndDisplayRoute(
        this.directionsService,
        this.directionsRenderer,
        this.origin,
        this.waypts,
        this.destination
      );
    },

    calculateAndDisplayRoute(
      directionsService,
      directionsRenderer,
      origin,
      waypts,
      destination
    ) {
      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: 'DRIVING',
          waypoints: waypts,
        },
        function(response, status) {
          if (status == 'OK') {
            directionsRenderer.setDirections(response);
          } else {
            console.log('Directions request failed due to ' + status);
            response.request.destination = this.destination;
            directionsRenderer.setDirections(response);
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 99.8%;
  height: 366px;
  margin: 0 auto;
  background: gray;
}
.legenda {
  width: 100%;
  height: 30px;
  display: flex;
}
</style>
